import { css, keyframes } from 'styled-components';

const Rotate = keyframes`
  from {
      transform:rotate(0deg);
  }
  to {
      transform:rotate(360deg);
  }
`;

export const rotate = css`
  @media (prefers-reduced-motion: no-preference) {
    animation-name: ${Rotate};
    animation-duration: 500ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
`;

export default Rotate;
